import { fmt, money } from "@/lib/api";

const tone = (pct) => (pct >= 100 ? "bg-red-500" : pct >= 80 ? "bg-amber-500" : "bg-emerald-500");
const label = (pct) => (pct >= 100 ? "text-red-700" : pct >= 80 ? "text-amber-700" : "text-emerald-700");

export const UsageMeter = ({ row, testid = "usage-meter" }) => {
  if (!row) return <div className="text-xs text-slate-400 font-mono" data-testid={testid}>No usage yet</div>;
  const unlimited = row.included === "unlimited";
  const pct = unlimited ? 0 : Number(row.pct || 0);
  return (
    <div className="w-full" data-testid={testid}>
      <div className="flex justify-between items-baseline text-xs mb-1.5 gap-2">
        <span className="font-mono text-slate-700" data-testid={`${testid}-words`}>
          {fmt(row.used)} / {unlimited ? "unlimited" : fmt(row.included)} words
        </span>
        {!unlimited && <span className={`font-mono font-medium ${label(pct)}`} data-testid={`${testid}-pct`}>{pct}%</span>}
      </div>
      <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
        <div className={`h-full ${tone(pct)} transition-[width] duration-500`} style={{ width: `${Math.min(pct, 100)}%` }} />
      </div>
      {row.extra_cents > 0 && (
        <div className="text-xs text-red-700 mt-1.5 font-medium" data-testid={`${testid}-extra`}>
          Extra usage this month: {money(row.extra_cents)}
        </div>
      )}
    </div>
  );
};
